import { useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import { renderRegexHighlight } from '../../helpers/renderColoredText';
import './HighlightedInput.css';

const HighlightedInput = ({
  value,
  onChange,
  lang,
  minRows = 2,
  spaceMarkerMode = 'native-width',
  error = false,
  inputProps = {},
}) => {
  const textareaRef = useRef(null);
  const highlightRef = useRef(null);

  const resizeTextarea = useCallback(target => {
    if (!target) return;

    target.style.height = 'auto';
    target.style.height = `${target.scrollHeight}px`;
  }, []);

  useEffect(() => {
    resizeTextarea(textareaRef.current);
  }, [value, resizeTextarea]);

  const handleChange = e => {
    resizeTextarea(e.target);
    onChange(e);
  };

  const handleScroll = e => {
    if (highlightRef.current) {
      highlightRef.current.scrollTop = e.target.scrollTop;
    }
  };

  return (
    <Box
      className={`highlighted-input-container${error ? ' highlighted-input-container-error' : ''}`}
    >
      {/*  Подсветка */}
      <Box ref={highlightRef} className="highlighted-input-overlay">
        {renderRegexHighlight(value, lang, {
          inheritTextMetrics: true,
          spaceMarkerMode,
        })}
      </Box>

      {/* Реальный textarea */}
      <textarea
        ref={textareaRef}
        className="highlighted-input-textarea"
        value={value}
        onChange={handleChange}
        onScroll={handleScroll}
        rows={minRows}
        {...inputProps}
      />
    </Box>
  );
};

HighlightedInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  lang: PropTypes.string,
  minRows: PropTypes.number,
  spaceMarkerMode: PropTypes.oneOf(['glyph', 'native-width', 'none']),
  error: PropTypes.bool,
  inputProps: PropTypes.object,
};

export default HighlightedInput;
